import {
  AlertCircle,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  Banknote,
  BarChart3,
  Building2,
  Calculator,
  Calendar,
  CarFront,
  Check,
  CheckCircle2,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  CircleAlert,
  CircleDashed,
  CircleDollarSign,
  CircleMinus,
  CirclePlus,
  CircleUserRound,
  Clock,
  Copy,
  CreditCard,
  Download,
  Edit3,
  Eye,
  EyeOff,
  Filter,
  FileText,
  Fingerprint,
  Gift,
  Grid3x3,
  HandCoins,
  Headphones,
  Heart,
  HelpCircle,
  Home,
  Hospital,
  Key,
  Link as LinkIcon,
  Loader,
  Lock,
  LogOut,
  Mail,
  Menu,
  MinusCircle,
  MoonStar,
  MoreHorizontal,
  MoreVertical,
  Phone,
  PiggyBank,
  Pill,
  Plus,
  QrCode,
  Receipt,
  Scale,
  Search,
  Share2,
  Shield,
  ShoppingCart,
  Stethoscope,
  Store,
  Sun,
  TrendingDown,
  TrendingUp,
  Trash2,
  Truck,
  User,
  UserCog,
  Users,
  Utensils,
  Wallet,
  X,
  XCircle,
  Zap,
  Bell,
  type LucideIcon,
} from 'lucide-react';

import type { propsIconsNames } from './interfaces';

export const ICON_MAP: Record<propsIconsNames, LucideIcon> = {
  'icon-chevron-left': ChevronLeft,
  'icon-chevron-right': ChevronRight,
  'icon-chevron-up': ChevronUp,
  'icon-chevron-down': ChevronDown,
  'icon-close': X,
  'icon-eye': Eye,
  'icon-eye-hide': EyeOff,
  'icon-home': Home,
  'icon-circle-money': CircleDollarSign,
  'icon-extract': FileText,
  'icon-user': User,
  'icon-circle-user': CircleUserRound,
  'icon-logout': LogOut,
  'icon-pencil': Edit3,
  'icon-filter': Filter,
  'icon-percent': BarChart3,
  'icon-security': Shield,
  'icon-receipt': Receipt,
  'icon-copy': Copy,
  'icon-out': LogOut,
  'icon-circle-check': CheckCircle2,
  'icon-notification': Bell,
  'icon-clock': Clock,
  'icon-search': Search,
  'icon-circle-close': XCircle,
  'icon-loader': Loader,
  'icon-calendar': Calendar,
  'icon-document': FileText,
  'icon-more-vertical': MoreVertical,
  'icon-check': Check,
  'icon-face-id': UserCog,
  'icon-fingerprint': Fingerprint,
  'icon-user-finance': Users,
  'icon-deal': HandCoins,
  'icon-pen': Edit3,
  'icon-email': Mail,
  'icon-phone': Phone,
  'icon-pin-location': Building2,
  'icon-download': Download,
  'icon-enterprise': Building2,
  'icon-callcenter': Headphones,
  'icon-pix': Zap,
  'icon-moneybag': Wallet,
  'icon-doublecoins': PiggyBank,
  'icon-filter-line': Filter,
  'icon-transfer': Banknote,
  'icon-key': Key,
  'icon-help': HelpCircle,
  'icon-sun': Sun,
  'icon-moon-stars': MoonStar,
  'icon-graphic-up': TrendingUp,
  'icon-trash': Trash2,
  'icon-arrow-up': ArrowUp,
  'icon-arrow-left': ArrowLeft,
  'icon-limits': Scale,
  'icon-grid': Grid3x3,
  'icon-share': Share2,
  'icon-car-crash': CarFront,
  'icon-parking': Truck,
  'icon-supply-money': CircleDollarSign,
  'icon-heart-frequency': Heart,
  'icon-hospital': Hospital,
  'icon-luggage': Truck,
  'icon-restaurant': Utensils,
  'icon-shopping-cart': ShoppingCart,
  'icon-bar-code': CreditCard,
  'icon-qr-code': QrCode,
  'icon-antecipar-ai': TrendingDown,
  'icon-circle-alert': CircleAlert,
  'icon-lock': Lock,
  'icon-more': Plus,
  'icon-gift': Gift,
  'icon-password-lock': Lock,
  'icon-password-check': CheckCircle2,
  'icon-password-error': XCircle,
  'icon-menu-hamburger': Menu,
  'icon-store': Store,
  'icon-calculator': Calculator,
  'icon-link': LinkIcon,
  'icon-ai': Zap,
  'icon-stethoscope': Stethoscope,
  'icon-flow': MoreHorizontal,
  'icon-hand-coins': HandCoins,
  'icon-weight': Scale,
  'icon-child': User,
  'icon-pill': Pill,
  'icon-circle-more': CirclePlus,
  'icon-circle-less': CircleMinus,
  'icon-less': MinusCircle,
  'icon-arrow-right': ArrowRight,
  'icon-whatsapp': Phone,
};

export const getIconComponent = (name: propsIconsNames | undefined): LucideIcon => {
  if (!name) return CircleDashed;
  return ICON_MAP[name] ?? CircleDashed;
};
